<template>
    <VanCell is-link center class="in-panel" :to="toUrl">
        <template #title>
            <div class="flex-row flex-y-center">
                <img :src="student.avatarUrl | resourceUrl" ref="student" class="avatar"
                     @error="handleRefAvatarError('student', student.gender)">
                <div class="text">
                    <div class="fs15px">{{student.name}}</div>
                    <div class="lh1_5em txt-gray">{{classNames}}</div>
                    <div class="lh1_5em" :class="{'txt-red': paid === 0}">{{paidText}}</div>
                </div>
            </div>
        </template>
    </VanCell>
</template>

<script>
    import RefAvatarErrorHandler from '@/mixins/RefAvatarErrorHandler';
    import Utils from '@/utils';

    export default {
        name: 'StudentOrder',
        mixins: [RefAvatarErrorHandler],
        props: {
            student: {
                type: Object,
                default() {
                    return {};
                },
            },
            paid: {
                type: Number,
                default: 0,
            },
        },
        computed: {
            paidText() {
                return this.paid === 0 ? '待交费' : '已交费';
            },
            classNames() {
                if (this.student.classes.length) {
                    return Utils.string.arrayJoin(this.student.classes.slice(0, 2).map((cls) => cls.name), ' / ');
                }
                return '';
            },
            toUrl() {
                const { orderMasterUuid } = this.$route.params;
                const studentUuid = this.student.uuid;
                let url = '';
                if (this.paid === 1) {
                    const query = { studentUuid };
                    url = `/order-masters/${orderMasterUuid}/detail${Utils.query.queryString(query)}`;
                } else {
                    url = `/order-masters/${orderMasterUuid}/orders/students/${studentUuid}`;
                }
                return url;
            },
        },
    };
</script>

<style scoped lang="less">
.avatar {
    width: 15vw;
    height: 15vw;
    border-radius: 50%;
    background-color: #eeffee;
    border: 1px solid #f1f6f1;
    display: block;
    margin-right: 0.8em;
}
.text {
    width: 50vw;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
